// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner {
  position: absolute;
  width: 100%;
  height: 100%;
}
@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.spinner img {
  border: none;
  box-shadow: none;
  width: 51px;
  height: 51px;
  animation: 1s linear infinite spinner;
  animation-play-state: inherit;
  position: absolute;
  top: calc(50% - 25px);
  left: calc(50% - 25px);
}
`, "",{"version":3,"sources":["webpack://./css/splash.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB","sourcesContent":[".spinner {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n@keyframes spinner {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner img {\n  border: none;\n  box-shadow: none;\n  width: 51px;\n  height: 51px;\n  animation: 1s linear infinite spinner;\n  animation-play-state: inherit;\n  position: absolute;\n  top: calc(50% - 25px);\n  left: calc(50% - 25px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
